import { request } from '../lib/http'

/**
 * @returns {Promise<Array>}
 */
export function fetchAll (queriesParams) {
  return request({
    url: 'vehicle-types',
    method: 'get',
    params: queriesParams
  })
}
